import Table from './Table';
import TableBody from './TableBody';
import TableHeader from './TableHeader';
import TableHeaderItem from './TableHeaderItem';
import TableRow from './TableRow';
import TableItem from './TableItem';
import TableName from './TableName';

export default {
  table: Table,
  thead: TableHeader,
  tbody: TableBody,
  th: TableHeaderItem,
  td: TableItem,
  tr: TableRow,
  tname: TableName,
};



// WEBPACK FOOTER //
// ./src/documents/SpreadSheetComponents/Parser.js